module.exports = __webpack_public_path__ + "assets/img/fh-logo.png";


//////////////////
// WEBPACK FOOTER
// ../assets/img/fh-logo.png
// module id = ../assets/img/fh-logo.png
// module chunks = 0